export const shadows = {
  none: 'none',
  light: '0px 1px 1px 0px rgba(0, 33, 82, 0.15), 0px 1px 3px 1px rgba(0, 33, 82, 0.15)',
  heavy: '0px 8px 12px 6px rgba(0, 33, 82, 0.15), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  floating: '0px 4px 8px 3px rgba(0, 33, 82, 0.15), 0px 1px 3px 0px rgba(0, 33, 82, 0.30)',
  innerLeft: 'inset 10px 0 8px -8px rgba(32, 35, 40, 0.12)',
  innerRight: 'inset -10px 0 8px -8px rgba(32, 35, 40, 0.12)',
} as const;
